import { useState } from 'react';
import styled from 'styled-components';
import { NotificationHistory } from '../../../2_domain/notification/notification';
import FlexBox from '../../core/components/box/flexBox';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import Description from './description';
import NotiIcon from './notiIcon';
import TimeStamp from './timeStamp';

interface NotificationPageProps {
  onClick: () => void;
}

const NotificationItem = styled.div<NotificationPageProps>`
  height: 92px;
  padding: 20px 0px;

  &:hover {
    cursor: pointer;
  }
`;

interface ItemPropsType {
  item: NotificationHistory;
  today: Date;
  onClick: () => void;
}

const Item = ({ onClick, item, today }: ItemPropsType) => {
  const [read, setRead] = useState(!item.isAlreadyOpened);

  const onClickItem = () => {
    onClick();
    setRead(false);
  };

  return (
    <NotificationItem onClick={onClickItem}>
      <Row justifyContent="space-between">
        <NotiIcon type={item.iconKind} isNew={read} />
        <SizedBox width={16} />
        <Description item={item} />
        <FlexBox></FlexBox>
        <TimeStamp today={today} item={item}></TimeStamp>
      </Row>
    </NotificationItem>
  );
};

export default Item;
